import { ArrowLeft } from '@nosinovacao/fe-icons';
import { Button, Sheet, useI18n, useInMediaQuery } from '@nosinovacao/nosid-mfe-common';
import { Link, Outlet, useRouter } from '@tanstack/react-router';
import { Fragment, useState } from 'react';
import { type RouteSheetProps } from './props';

export function RouteSheetLight({ onClose, options }: Readonly<RouteSheetProps>) {
  const { t } = useI18n();
  const isTablet = useInMediaQuery('tablet');
  const backIconSize = isTablet ? 20 : 32;
  const [open, setOpen] = useState(true);
  const router = useRouter();
  const useCustomBack = !!options?.onBack;
  const useHistoryBack = !useCustomBack && !!options?.backAsRouterNavigateBack;
  const ButtonComponent = useHistoryBack || useCustomBack ? Fragment : Link;
  return (
    <Sheet
      open={open}
      onOpenChange={(o) => {
        setOpen(o);
        if (!o)
          setTimeout(() => {
            onClose();
          }, 300);
      }}
      skin="light"
      className="z-[60] flex flex-col"
      overlayClassName="z-[60] max-tablet:bg-transparent"
      animationDirection={isTablet ? 'right' : 'bottom'}
      title={options?.title || undefined}
      subtitle={options?.subtitle || undefined}
      icon={options?.icon || undefined}
      back={
        options?.hasBack ? (
          <Button
            data-tid="button-back"
            skin="light"
            variant="tertiary"
            asChild={!useHistoryBack && !useCustomBack}
            onClick={
              useCustomBack
                ? options.onBack
                : useHistoryBack
                  ? () => router.history.back()
                  : undefined
            }
          >
            <ButtonComponent to="..">
              <ArrowLeft width={backIconSize} height={backIconSize} />
              {isTablet ? t('Common.Back') : null}
            </ButtonComponent>
          </Button>
        ) : null
      }
    >
      <Outlet />
    </Sheet>
  );
}
